import { render, staticRenderFns } from "./ConfirmDetail.vue?vue&type=template&id=3ddaee06&scoped=true"
import script from "./ConfirmDetail.vue?vue&type=script&lang=js"
export * from "./ConfirmDetail.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDetail.vue?vue&type=style&index=0&id=3ddaee06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddaee06",
  null
  
)

export default component.exports